import './libs/slider-swiffy/index.js';

import './main/js/index.js'
import "./main/scss/index.scss";